import { createSelector } from '@reduxjs/toolkit';
import selectStreamsList from './selectStreamsList';

export default createSelector(selectStreamsList, (streams) => streams?.sort((a, b) => b.id - a.id) ?? []);
